// /teams/:teamId/projects/:projectId — auto-redirects to the Flows tab,
// which is the project's main surface per the shape brief.

import { Navigate, useParams } from 'react-router-dom'

export function ProjectHome() {
  const { teamId, projectId } = useParams()
  return <Navigate to={`/teams/${teamId}/projects/${projectId}/flows`} replace />
}
